// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"3e9465c0","60":"9062d517","68":"ec1d5e5a","72":"b1d62ba8","120":"382f6a07","132":"b1b08763","344":"448aa34f","448":"cee5cbda","453":"842e55cd","619":"f7fbc4f6","633":"803514a9","739":"a87a3193","752":"cb6da346","788":"5ab19190","820":"5578a00b","944":"fd286681"}[chunkId] + ".chunk.js";
};